import React from 'react';
// import { Link, NavLink } from 'react-router-dom';
import { NavHashLink as NavLink } from 'react-router-hash-link';
// import { HashLink as Link } from 'react-router-hash-link';
import styled from 'styled-components/macro';
import { device } from '../../style/Sizes';
import LogoRed from '../../assets/images/LogoLightRed@2x.png';
import LogoGreen from '../../assets/images/LogoLightGreen@2x.png';
import { isMobile } from 'react-device-detect';

const HeaderContainer = styled.div`
  position: fixed;
  top: ${props => (props.visible ? 0 : '-64px')};
  z-index: 9999;
  height: 56px;
  width: 100%;
  /* border-bottom: 1px solid #861657;  */
  /* border-bottom: 1px solid rgba(147,225,216,0.5);  */
  /* border-bottom: 1px solid rgba(134,22,87,0.3);  */
  /* background: green; */
  /* background: rgba(166,230,223,0.2); */
  background: rgba(255,255,255,0.8);
  transition: top 0.3s; 


  @media ${device.mobileL} {
  height:64px;  }
`;

const HeaderContentContainer = styled.div`
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
`;

const LogoContainer = styled.div`
  margin-top: 8px;
  margin-left: 16px;
  width: 47px;

  @media ${device.mobileL} {
    margin-left: 24px;
    margin-top: 16px;
  }
`;

const StyledLogo = styled.div`
  height: 40px;
  width: auto;
  background: url(${LogoRed}) no-repeat left/contain;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;

  :hover {
    background: ${() =>
      !isMobile ? `url(${LogoGreen}) no-repeat left/contain` : ''};
  }

  :active {
    background: url(${LogoGreen}) no-repeat left/contain;
  }
`;

const LinkUl = styled.ul`
  list-style: none;
  position: absolute;
  bottom: -5px;
  right: 8px;
  overflow-x: hidden;
  overflow-y: hidden;

  @media ${device.maxMobileS} {
    right: 12px;
    bottom: -4px;
  }

  > li {
    position: relative;
    display: inline-block;
  }
`;

const StyledLink = styled(NavLink)`
  color: #223742;
  font-size: 20px;
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  padding: 0 8px;
  transition: background-color 1s ease;

  :hover {
    color: #93e1d8;
  }

  :active {
    color: #93e1d8;
  }

  @media ${device.maxMobileS} {
    font-size: 18px;
    /* line-height: 43px; */
  }

  @media ${device.mobileL} {
    padding: 12px;
  }
`;

const setActiveStyle = {
  fontFamily: 'miller-display, serif',
  fontWeight: 700,
  fontStyle: 'normal',
  color: '#861657'
};

const Header = props => {
  return (
    <HeaderContainer id="navbar" visible={props.visible}>
      <HeaderContentContainer>
        <LogoContainer>
          {/* <a href="http://localhost:3000" title="home"> */}
          <a href="http://www.peterfrommann.de" title="home">
            <StyledLogo alt="logo" />
          </a>
          {/* <Link smooth exact="true" to="/#home">
            <StyledLogo alt="logo" />
          </Link> */}
        </LogoContainer>
        <div>{props.visible}</div>
        <LinkUl>
          <li>
            <StyledLink
              // smooth
              activeStyle={setActiveStyle}
              scroll={el =>
                // el.scrollIntoView({ behavior: 'instant', block: 'end' })
                el.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
              exact={true}
              to={{
                pathname: '/',
                // search: '?id="#work"',
                hash: '#work'
              }}
            >
              {/* <StyledLink
              smooth
              activeStyle={setActiveStyle}
              exact={true}
              to={{
                pathname: '/',
                // search: '?id="#work"',
                hash: '#work'
              }}
            > */}
              Work
            </StyledLink>
          </li>
          <li>
            <StyledLink activeStyle={setActiveStyle} exact={true} to="/about">
              About Me
            </StyledLink>
          </li>
          <li>
            <StyledLink activeStyle={setActiveStyle} exact={true} to="/contact">
              Contact
            </StyledLink>
          </li>
        </LinkUl>
      </HeaderContentContainer>
    </HeaderContainer>
  );
};

export default Header;
